import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDownload = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M12 16.1168L7.11675 11.2332L8.3 10.0333L11.1668 12.9V4H12.8333V12.9L15.7 10.0333L16.8833 11.2332L12 16.1168ZM5.66675 20C5.21675 20 4.82642 19.8348 4.49575 19.5042C4.16525 19.1736 4 18.7833 4 18.3333V14.95H5.66675V18.3333H18.3333V14.95H20V18.3333C20 18.7833 19.8348 19.1736 19.5042 19.5042C19.1736 19.8348 18.7833 20 18.3333 20H5.66675Z",
		fill: "currentColor"
	})]
});
const ForwardRef = forwardRef(SvgDownload);
export default ForwardRef;
